export interface ModalContent {
  icon: string;
  headline: string;
  subheadline: string;
  body: string;
  bodyParams: { [key: string]: string };
  button: string;
  secondaryButton: string;
  userConfirmationCheckbox?: string;
}

export interface ModalStyle {
  container: { [key: string]: string };
  icon: { [key: string]: string };
  headline: { [key: string]: string };
  subheadline: { [key: string]: string };
  body: { [key: string]: string };
  button: { [key: string]: string };
  primaryButtonType: string;
  secondaryButton: { [key: string]: string };
  secondaryButtonType: string;
  userConfirmationCheckbox: { [key: string]: string };
}

export enum ModalButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  CLOSE = 'CLOSE',
}
